import * as Styled from '../styled';
import { PaperAirplane, Button } from '~components';
import { useNavigate } from 'react-router-dom';

function ResponseError() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/');
  };

  return (
    <Styled.Wrapper role="region">
      <PaperAirplane />
      <Styled.Title>Erro no envio dos dados</Styled.Title>
      <Styled.Description variant="sub300">
        Ocorreu um problema de comunicação com nosso servidor para o envio dos
        dados.
      </Styled.Description>
      <Button variant="primary" onClick={handleClick}>
        Tentar novamente mais tarde
      </Button>
    </Styled.Wrapper>
  );
}

export default ResponseError;
